angular.module('tgaApp').config(['ChartJsProvider',
  function (ChartJsProvider) {
    // Configure all charts
    ChartJsProvider.setOptions({});

    // Configure pie charts
    ChartJsProvider.setOptions('pie', {
      responsive: false,
      showTooltips: false,
      legend: {
        display: true,
        labels: {
          fontColor: 'white',
          padding: 40,
          fontSize: 30,
        },
      },
      pieceLabel: {
        render(args) {
          return `${args.percentage}%`;
        },
        fontColor(data) {
          function hexToRgb(hex) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result
              ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16),
              }
              : null;
          }
          const rgb = hexToRgb(data.dataset.backgroundColor[data.index]);
          const threshold = 140;
          const luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
          return luminance > threshold ? 'black' : 'white';
        },
        fontSize: 30,
        precision: 2,
      },
    });

    // Configure bar charts
    ChartJsProvider.setOptions('bar', {
      responsive: false,
      showTooltips: false,
      scales: {
        yAxes: [
          {
            ticks: {
              fontColor: 'white',
              fontSize: 30,
              min: 0,
              beginAtZero: true,
              callback(value) {
                return `${value}%`;
              },
            },
            gridLines: {
              display: false,
              color: 'white',
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              fontColor: 'white',
              fontSize: 30,
            },
            gridLines: {
              display: false,
              color: 'white',
            },
            barPercentage: 0.6,
          },
        ],
      },
    });

    Chart.defaults.global.tooltips.enabled = false;
    Chart.defaults.global.defaultFontSize = 30;
  },
]);
